// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accounts-select[data-v-276a7801]  .multiselect__option--group:not(:has(.group-label)){display:none;height:0;min-height:0;padding:0;overflow:hidden;pointer-events:none}", ""]);
// Exports
module.exports = exports;
